import * as React from "react";
import logo from "modules/development/assets/images/rubk-logo.svg";
import { Grid, CssBaseline } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Redirect } from "react-router-dom";
import i18n from "i18n";
import getQueryVariable from "common/actions/query";
import { AccountService } from "modules/account/AccountService";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
  root: {
    flexGrow: 1,
    backgroundColor: "#000000,5%",
    fontWeight: 700,
    fontFamily: "Roboto",
  },
  header: {
    backgroundColor: "#333",
    width: "100%",
    height: 64,
    padding: "20px 24px",
  },
  fullWidth: {
    width: "100%",
  },
  innerRoot: {
    width: "100%",
    padding: 2,
    paddingLeft: 23,
    height: 60,
    lineHeight: "60px",
    backgroundColor: "white",
  },
  createAccount: {
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
  },
  formContainer: {
    margin: "0 auto",
    width: 640,
    paddingTop: 120,
  },
  textField: {
    marginTop: 16,
    width: "640px",
    margin: "0 auto",
  },
  buttonContainer: {
    margin: "0 auto",
    paddingTop: "2.5rem",
  },
  messageContainer: {
    padding: 60,
    textAlign: "center" as any,
  },
  messageFontFormat: {
    color: "#757575",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "23px",
  },
});

type IProps = {};

class VerifyEmail extends React.Component<IProps> {
  state = {
    verified: "",
    redirect: "",
    componentMounted: false,
  };

  componentDidMount() {
    let oobCode = getQueryVariable("oobCode");
    if (oobCode != null) {
      AccountService.verifyEmail(oobCode, (success, emailVerified) => {
        if (success) {
          this.setState({ email: emailVerified });
          AccountService.loadUserFromEmail(emailVerified, true, (user) => {
            this.setState({ verified: true });
            this.setState({ componentMounted: true });
          });
        } else {
          this.setState({ componentMounted: true });
        }
      });
    }
  }

  handleClickGoToLogin = () => {
    const continueUrl = getQueryVariable("continueUrl") || "";
    const rubkProduct = decodeURIComponent(continueUrl).split("/").pop();

    if (rubkProduct) {
      window.open(`https://${rubkProduct}.firebaseapp.com/`);
      return;
    }
    this.setState({
      redirect: this.state.verified ? "/menu/development" : "/Login",
    });
  };

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container>
          <Grid item xs={12}>
            <div className={css(styles.header)}>
              <img style={{ height: "21px" }} src={logo} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={css(styles.fullWidth)}>
              {this.state.redirect !== "" && (
                <Redirect to={this.state.redirect} />
              )}

              {this.state.componentMounted && (
                <div className={css(styles.messageContainer)}>
                  {!this.state.verified && (
                    <div>
                      <p className={css(styles.messageFontFormat)}>
                        {i18n.login.emailError}
                      </p>
                      <p className={css(styles.messageFontFormat)}>
                        {i18n.login.resendEmail}
                      </p>
                    </div>
                  )}
                  {this.state.verified && (
                    <div>
                      <p className={css(styles.messageFontFormat)}>
                        {i18n.login.emailSucess}
                      </p>
                      <p className={css(styles.messageFontFormat)}>
                        {i18n.login.emailSucessSubmessage}
                      </p>
                    </div>
                  )}
                  <div className={css(styles.buttonContainer)}>
                    <Button
                      onClick={() => this.handleClickGoToLogin()}
                      variant="contained"
                      className={css(styles.createAccount)}
                    >
                      {this.state.verified
                        ? i18n.menu.development
                        : i18n.login.enterRubk}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default VerifyEmail;



// WEBPACK FOOTER //
// ./src/modules/account/components/pages/VerifyEmail.tsx